var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('rect',{staticClass:"chartHighlight",attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }